export default __webpack_public_path__ + "f2fa96951c9b28d7bb264c846c322804.png";